var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedIcon = function SvgCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 134 167.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.571 70.766 32.913 32.913a5.21 5.21 0 0 0 7.366 0L119.929 41.6a5.21 5.21 0 0 0 0-7.366 5.21 5.21 0 0 0-7.366 0L54.167 92.63 24.937 63.4a5.21 5.21 0 0 0-7.366 0 5.21 5.21 0 0 0 0 7.366"
  })));
};
export default SvgCheckedIcon;